(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sms-tshirt-catalogue"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sms-tshirt-catalogue')) {
  customElements.define('sms-tshirt-catalogue',class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return; this.ready=true;
      this.cards=Array.from(this.querySelectorAll('[data-model-card]')).map(card=>({card,photos:JSON.parse(card.querySelector('[data-model-photos]').textContent),index:0}));
      if(matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.cardCursor=0;
      this.timer=setInterval(()=>{
        if(document.hidden || this.loadingColour) return;
        const visible=this.cards.filter(item=>{const r=item.card.getBoundingClientRect();return item.photos.length>1 && r.bottom>=0 && r.top<=innerHeight;});
        if(!visible.length) return;
        const item=visible[this.cardCursor++ % visible.length];
        const nextIndex=(item.index+1)%item.photos.length;
        const next=item.photos[nextIndex],image=item.card.querySelector('[data-model-photo]');
        this.loadingColour=true;
        const preload=new Image();
        preload.onload=()=>{this.loadingColour=false;if(!this.isConnected)return;item.index=nextIndex;image.src=next.url;item.card.querySelector('[data-model-colour]').textContent=next.label;};
        preload.onerror=()=>{this.loadingColour=false;};
        preload.src=next.url;
      },1800);
    }
    disconnectedCallback(){clearInterval(this.timer);this.ready=false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sms-tshirt-orders"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sms-tshirt-orders')) {
  customElements.define('sms-tshirt-orders', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-tee-config]').textContent);
      this.t = this.config.text;
      this.shirtStyle = 'polo'; this.mode = 'quick'; this.busy = false;
      this.$ = selector => this.querySelector(selector);
      this.querySelectorAll('[data-style]').forEach(button => button.addEventListener('click', () => { this.shirtStyle = button.dataset.style; this.buildModels(); }));
      this.querySelectorAll('[data-mode]').forEach(button => button.addEventListener('click', () => { this.mode = button.dataset.mode; this.buildOptions(); }));
      this.$('[data-fabric]').addEventListener('change', () => this.buildOptions());
      this.$('[data-colour]').addEventListener('change', () => { this.$('[data-accept]').checked = false; this.buildSizes(); this.update(); });
      this.$('[data-pack]').addEventListener('change', () => { this.$('[data-accept]').checked = false; this.update(); });
      this.$('[data-packs]').addEventListener('input', () => this.update());
      this.$('[data-accept]').addEventListener('change', () => this.update());
      this.$('form').addEventListener('submit', event => this.submit(event));
      if (location.hash === '#plain-tshirts') this.$('details').open = true;
      this.buildModels();
    }
    option(select, value, label, disabled = false) { const option = new Option(label, value); option.disabled = disabled; select.add(option); }
    model() { return this.config.models.find(model => model.id === this.$('[data-fabric]').value); }
    product() { const model = this.model(); return model && model[this.mode] && Array.isArray(model[this.mode].variants) ? model[this.mode] : null; }
    values(variant) { return variant.options || [variant.option1,variant.option2,variant.option3].filter(value => value != null); }
    index(product, names) { return (product?.options || []).findIndex(option => names.includes(String(option.name || option).toLowerCase())); }
    buildModels() {
      const select = this.$('[data-fabric]'); select.replaceChildren();
      this.config.models.filter(model => model.style === this.shirtStyle).forEach(model => this.option(select, model.id, this.t[model.fabric] || model.fabric));
      if (!this.config.models.some(model => model.style === this.shirtStyle && model.fabric === 'cotton')) this.option(select, '', this.t.cotton_pending, true);
      this.querySelectorAll('[data-style]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.style === this.shirtStyle)));
      this.buildOptions();
    }
    buildOptions() {
      const model = this.model(); if (!model) return;
      const product = this.product();
      this.$('[data-accept]').checked = false; this.$('[data-packs]').value = '1';
      this.querySelectorAll('[data-mode]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mode === this.mode)));
      this.$('[data-quick-fields]').hidden = this.mode !== 'quick'; this.$('[data-factory-fields]').hidden = this.mode !== 'factory';
      this.$('[data-mode-note]').textContent = this.t[this.mode + '_note'];
      this.$('[data-order-label]').textContent = this.t[this.mode];
      this.$('[data-model-title]').textContent = (this.t[model.fabric] || model.fabric) + ' · ' + this.t[this.shirtStyle];
      const colour = this.$('[data-colour]'); colour.replaceChildren();
      const colourIndex = this.index(product, ['colour','color']);
      const colours = [...new Set((product?.variants || []).map(variant => this.values(variant)[colourIndex]).filter(value => value && !/to confirm|pending/i.test(value)))];
      colours.forEach(value => this.option(colour, value, value));
      if (!colours.length) this.option(colour, '', this.t.colour_pending);
      colour.disabled = !colours.length;
      const pack = this.$('[data-pack]'); pack.replaceChildren();
      const packs = String(model.packs || '').split(',').map(value => Number(value.trim())).filter(value => Number.isInteger(value) && value > 0);
      packs.forEach(value => this.option(pack, String(value), value + ' ' + this.t.pieces + ' / ' + this.t[model.unit]));
      if (!packs.length) this.option(pack, '', this.t.pack_pending);
      pack.disabled = !packs.length;
      this.$('[data-breakdown]').textContent = model.breakdown || this.t.breakdown_pending;
      this.buildSizes(); this.update();
    }
    buildSizes() {
      const model = this.model(), product = this.product(), host = this.$('[data-sizes]'); host.replaceChildren();
      const sizeIndex = this.index(product, ['size','sizes']);
      const known = [...new Set((product?.variants || []).map(variant => this.values(variant)[sizeIndex]).filter(value => value && !/confirm|mixed|pending/i.test(value)))];
      const sizes = known.length ? known : String(model?.sizes || '').split(',').map(value => value.trim()).filter(Boolean);
      sizes.forEach(size => { const label = document.createElement('label'); label.append(document.createTextNode(size)); const input = document.createElement('input'); input.type = 'number'; input.min = '0'; input.max = '99999'; input.step = '1'; input.value = '0'; input.inputMode = 'numeric'; input.dataset.size = size; input.addEventListener('input', () => this.update()); label.append(input); host.append(label); });
      this.$('[data-factory-terms]').textContent = (model?.minimum > 0 ? this.t.minimum + ' ' + model.minimum + ' ' + this.t.pieces + '. ' : '') + (model?.lead ? this.t.lead + ' ' + model.lead : this.t.lead_pending);
    }
    selection() {
      const model = this.model(), product = this.product(), colour = this.$('[data-colour]').value;
      const result = { items: [], count: 0, total: 0, reason: '', variant: null };
      const c = this.index(product, ['colour','color']), p = this.index(product, ['pack']), s = this.index(product, ['size','sizes']);
      if (this.mode === 'quick') {
        const pieces = Number(this.$('[data-pack]').value), packs = Number(this.$('[data-packs]').value);
        if (!Number.isInteger(packs) || packs < 1 || packs > 999) result.reason = this.t.quantity_required;
        if (!pieces) result.reason = this.t.pack_not_confirmed;
        result.count = pieces > 0 && Number.isInteger(packs) && packs > 0 && packs <= 999 ? pieces * packs : 0;
        const variant = product?.variants.find(variant => this.values(variant)[c] === colour && this.values(variant)[p] === pieces + ' pieces' && this.values(variant)[s] === 'Mixed sizes');
        result.variant = variant;
        if (variant) { result.total = variant.price * packs; result.items = [{id:variant.id,quantity:packs,properties:{'Order type':this.t.quick,'Shirts per pack':String(pieces),'Sizes':this.t.mixed,'Size mix':model.breakdown || this.t.breakdown_pending}}]; }
        if (!this.$('[data-accept]').checked && !result.reason) result.reason = this.t.accept_required;
      } else {
        this.querySelectorAll('[data-size]').forEach(input => {
          const quantity = Number(input.value);
          if (!Number.isInteger(quantity) || quantity < 0 || quantity > 99999) { result.reason = this.t.quantity_required; return; }
          result.count += quantity;
          if (!quantity) return;
          const variant = product?.variants.find(variant => this.values(variant)[c] === colour && this.values(variant)[s] === input.dataset.size);
          if (!variant || !variant.available || variant.price <= 0) result.reason = this.t.unavailable;
          else { result.total += variant.price * quantity; result.items.push({id:variant.id,quantity,properties:{'Order type':this.t.factory,'Lead time':model.lead}}); }
        });
        if (!result.count) result.reason = this.t.size_required;
        else if (model.minimum > result.count) result.reason = this.t.minimum + ' ' + model.minimum + ' ' + this.t.pieces;
      }
      const enabled = this.config.ready && model?.[this.mode + 'Ready'] && product && colour && (this.mode !== 'factory' || (model.minimum > 0 && model.lead));
      if (!enabled) result.reason = this.t.price_pending;
      else if (this.mode === 'quick' && (!result.variant?.available || result.variant.price <= 0)) result.reason = this.t.unavailable;
      result.ready = !!enabled && !result.reason && result.items.length > 0 && result.total > 0;
      result.showPrice = !!enabled && result.total > 0 && ![this.t.unavailable,this.t.quantity_required,this.t.pack_not_confirmed].includes(result.reason);
      return result;
    }
    update() {
      const selection = this.selection();
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.config.currency,currencyDisplay:'code'}).format(cents / 100);
      this.$('[data-count]').textContent = selection.count + ' ' + this.t.pieces;
      this.$('[data-unit]').textContent = selection.showPrice && selection.count ? money(selection.total / selection.count) : '—';
      this.$('[data-total]').textContent = selection.showPrice ? money(selection.total) : '—';
      this.$('[data-status]').textContent = selection.reason;
      this.$('[data-submit]').disabled = !selection.ready || this.busy;
      this.$('[data-submit]').textContent = this.busy ? this.t.adding : selection.ready ? this.t.add : this.t.not_ready;
      this.updatePhoto(selection.variant);
    }
    updatePhoto(variant) {
      const model = this.model(), product = this.product();
      const src = variant?.featured_image?.src || model?.image || product?.featured_image;
      const key = typeof src === 'string' ? src : '';
      if (this.photoKey === key) return;
      this.photoKey = key; const host = this.$('[data-photo]'); host.replaceChildren();
      if (key && /^(https:\/\/|\/\/|\/)/.test(key)) { const image = document.createElement('img'); image.src = key; image.alt = this.$('[data-model-title]').textContent; image.width = 1000; image.height = 1000; image.loading = 'lazy'; image.addEventListener('error', () => { host.textContent = this.t.photo_pending; }, {once:true}); host.append(image); }
      else host.textContent = this.t.photo_pending;
    }
    async submit(event) {
      event.preventDefault(); if (this.busy) return;
      const selection = this.selection(); if (!selection.ready) { this.update(); return; }
      this.busy = true; this.update();
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:selection.items})});
        const data = await response.json(); if (!response.ok) throw new Error(data.description || data.message || this.t.error);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) { this.busy = false; this.update(); this.$('[data-status]').textContent = error.message || this.t.error; }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
